import React from "react";

// css
import "./Team.css";

const TeamHeader = () => {
  return (
    <section id="team" className="team-header">
      <div class="main-padding">
        <div class="main-margin">
          <h1 className="main-header t-white">Team</h1>
        </div>
      </div>
    </section>
  );
};

export default TeamHeader;
